/* eslint-disable react/no-array-index-key */
/* eslint-disable radix */
/* eslint-disable react/prop-types */
import React from 'react';
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
} from 'reactstrap';
import { Container } from './styles';

function Card({ modulos, form, loading, handleSubmit, setForm }) {
  return (
    <Container>
      <h1>Cadastrar menu</h1>
      <Form style={{ width: '100%' }} onSubmit={handleSubmit}>
        <Row form>
          <Col md={6}>
            <FormGroup>
              <Label>Nome do menu</Label>
              <Input
                type="text"
                placeholder="Insira o nome do menu"
                maxLength={200}
                onChange={(e) => setForm({ ...form, nome: e.target.value })}
                required
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Descrição do menu</Label>
              <Input
                type="text"
                placeholder="Insira a descrição do menu"
                maxLength={500}
                onChange={(e) =>
                  setForm({ ...form, descricao: e.target.value })
                }
                required
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col md={6}>
            <FormGroup>
              <Label>
                <span>(opcional)</span> Nome da imagem
              </Label>
              <Input
                type="text"
                placeholder="Insira o nome da imagem"
                maxLength={50}
                onChange={(e) =>
                  setForm({ ...form, nomeImagem: e.target.value })
                }
                required
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Selecione um módulo</Label>
              <Input
                placeholder="Selecione..."
                type="select"
                onChange={(e) => setForm({ ...form, idModulo: e.target.value })}
                defaultValue="DEFAULT"
              >
                <option value="DEFAULT" disabled>
                  Selecione...
                </option>

                {modulos.map((modulo, index) => (
                  <option key={index} value={modulo.id}>
                    {modulo.nome}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col md={6}>
            <FormGroup>
              <Label>Selecione o tipo de página</Label>
              <Input
                placeholder="Selecione..."
                type="select"
                onChange={(e) =>
                  setForm({ ...form, tipoPagina: e.target.value })
                }
                defaultValue="DEFAULT"
              >
                <option value="DEFAULT" disabled>
                  Selecione...
                </option>
                <option value="M">Menu</option>
                <option value="O">Opção</option>
              </Input>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Rota do menu</Label>
              <Input
                type="text"
                disabled={form.tipoPagina !== 'O'}
                placeholder="Insira a rota do menu"
                onChange={(e) => setForm({ ...form, url: e.target.value })}
                required
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md="6">
            <FormGroup>
              <Label for="name">Ordem </Label>
              <Input
                type="number"
                name="ordem"
                id="ordem"
                placeholder="Insira a ordem númerica"
                max={1000}
                min={0}
                onChange={(e) => setForm({ ...form, ordem: e.target.value })}
                required
              />
            </FormGroup>
          </Col>
          <Col md="6">
            <FormGroup tag="fieldset">
              <Label>Situação cadastral</Label>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="radio1"
                    onChange={() =>
                      setForm({ ...form, idSituacaoCadastral: 1 })
                    }
                  />
                  Ativo
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="radio1"
                    onChange={() =>
                      setForm({ ...form, idSituacaoCadastral: 2 })
                    }
                  />
                  Inativo
                </Label>
              </FormGroup>
            </FormGroup>
          </Col>
        </Row>
      </Form>

      {loading ? (
        <Button color="primary" disabled>
          <Spinner size="sm" color="light" />
        </Button>
      ) : (
        <Button color="primary" onClick={handleSubmit}>
          Cadastrar
        </Button>
      )}
    </Container>
  );
}

export default Card;
